import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button } from "@/components/design-system";
import { api, formatApiError } from "@/lib/api";
import { TID } from "@/lib/testIds";

export default function VerifyEmail() {
  const [sp] = useSearchParams();
  const token = sp.get("token");
  const [state, setState] = useState({ status: token ? "loading" : "missing", message: "" });

  useEffect(() => {
    if (!token) return;
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setState({ status: "ok", message: "Your email is confirmed. You can now use every feature." });
      } catch (err) {
        setState({ status: "error", message: formatApiError(err) });
      }
    })();
  }, [token]);

  return (
    <AuthLayout eyebrow="Email verification" title={state.status === "ok" ? "You're verified." : "Confirming your email"}>
      <div data-testid={TID.auth.verifyStatus} className="space-y-4">
        {state.status === "loading" && <p className="text-[#0B1F3A]/70">Please wait…</p>}
        {state.status === "missing" && <p className="text-[#0B1F3A]/70">This page needs a verification token. Please use the link from your email.</p>}
        {state.status === "ok" && <p className="text-[#0B1F3A]/80">{state.message}</p>}
        {state.status === "error" && <p className="text-red-600">{state.message}</p>}
        <div className="flex gap-3 pt-2">
          <Link to="/app"><Button variant="primary">Open the app</Button></Link>
          <Link to="/"><Button variant="ghost">Back to home</Button></Link>
        </div>
      </div>
    </AuthLayout>
  );
}
